import React from 'react'

import FourColumnsDatapoints from '../../../FourColumnsDatapoints'

export default function YieldTable({ yields }) {
  let row = []

  return (
    <div>
      {yields.map((yieldObj, index) => {
        if (index % 4 === 0) {
          row = []
          row.push({
            label: yieldObj.name,
            value: yieldObj.value,
            labelHasPopover: true,
            popover: {
              content: yieldObj.popover.content[0],
              header: yieldObj.popover.title,
              position: 'top',
            },
          })
        } else {
          row.push({
            label: yieldObj.name,
            value: yieldObj.value,
            labelHasPopover: true,
            popover: {
              content: yieldObj.popover.content[0],
              header: yieldObj.popover.title,
              position: 'top',
            },
          })
        }

        if (row.length === 4) {
          return <FourColumnsDatapoints datapoints={row} key={index} />
        }
      })}
    </div>
  )
}
